export enum Status {
  OPEN = 'OPEN',
  ACCEPTED = 'ACCEPTED',
  IN_WORK = 'IN_WORK',
  COMPLETED = 'COMPLETED',
  CLOSED = 'CLOSED'
}
